

export class MapOutputWithoutStatus implements IMapOutputWithoutStatus {
    /** The auto-generated id of the map master */
    map_id!: number;
    /** The map name with 255 character limit */
    map_name!: string;

    constructor(data?: IMapOutputWithoutStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.map_id = _data["map_id"];
            this.map_name = _data["map_name"];
        }
    }

    static fromJS(data: any): MapOutputWithoutStatus {
        data = typeof data === 'object' ? data : {};
        let result = new MapOutputWithoutStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["map_id"] = this.map_id;
        data["map_name"] = this.map_name;
        return data; 
    }
}

export interface IMapOutputWithoutStatus {
    /** The auto-generated id of the map master */
    map_id: number;
    /** The map name with 255 character limit */
    map_name: string;
}

